import en from 'languages/en';

export const dictionaryList = {
    en,
};

export const languageOptions = [
    { id: 'en', text: 'English' }
];
